import styled from "@emotion/styled";

interface MainLayoutProps {
	children: React.ReactNode;
}

export const MainLayout = (props: MainLayoutProps) => {
	const a = 1;
	return <MainLayoutContainer>{props.children}</MainLayoutContainer>;
};

const MainLayoutContainer = styled.div`
	min-width: 100vw;
	min-height: 100vh;
	background-color: #fff;
	position: relative;
`;
